export default __webpack_public_path__ + "static/media/swap_btn.354d38da.png";